import React from 'react';
import SectionComponent from "./SectionComponent";
import { IMG_STRUCTURAL } from "../../data/constructionServiceImages";

function StructuralWorks() {
  return (
    <SectionComponent
      images={IMG_STRUCTURAL}
      titles={{
        mainTitle: "Structural works",
        subTitle: "Alterations, openings, and temporary works coordination",
        sectionTitle1: "Engineer alignment",
        sectionTitle2: "Safe execution on live sites",
        sectionTitle3: "Inspections & records",
        sectionTitle4: "Project photography",
      }}
      descriptions={{
        sectionDescription1: "We execute structural packages in step with the engineer’s sequence: propping, openings, steel, and concrete pours with hold points agreed in advance.",
        sectionDescription2: "Where projects sit in occupied buildings, we plan logistics, noise, and temporary works so risk is controlled without freezing the wider programme.",
        sectionDescription3: "Critical stages are photographed and recorded for consultant sign-off, giving architects clear evidence of compliance on site.",
        imageAlt: "Structural and envelope works"
      }}
      galleryLink="/projects/structural"
      seo={{
        title: "Structural works",
        description: "Structural alterations and coordination with engineers for architects and project teams. MA Renovations."
      }}
    />
  )
}

export default StructuralWorks;
